var jacketSizeChart = [
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "14.9",
        "Hip Width": "17.1",
        "Center Back Length": "27.4",
        "Left Sleeve Length": "22.9",
        "Right Sleeve Length": "22.9",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "15.3",
        "Hip Width": "17.4",
        "Center Back Length": "27.5",
        "Left Sleeve Length": "23",
        "Right Sleeve Length": "23",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "15.7",
        "Hip Width": "17.8",
        "Center Back Length": "27.6",
        "Left Sleeve Length": "23.1",
        "Right Sleeve Length": "23.1",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.1",
        "Hip Width": "18.2",
        "Center Back Length": "27.7",
        "Left Sleeve Length": "23.2",
        "Right Sleeve Length": "23.2",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "16.4",
        "Hip Width": "18.6",
        "Center Back Length": "27.8",
        "Left Sleeve Length": "23.3",
        "Right Sleeve Length": "23.3",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "16.8",
        "Hip Width": "18.9",
        "Center Back Length": "27.9",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "17.2",
        "Hip Width": "19.3",
        "Center Back Length": "28",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "17.6",
        "Hip Width": "19.7",
        "Center Back Length": "28.1",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "17.9",
        "Hip Width": "20.1",
        "Center Back Length": "28.2",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "18.3",
        "Hip Width": "20.4",
        "Center Back Length": "28.3",
        "Left Sleeve Length": "23.8",
        "Right Sleeve Length": "23.8",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "18.7",
        "Hip Width": "20.8",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "23.9",
        "Right Sleeve Length": "23.9",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.1",
        "Hip Width": "21.2",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "19.4",
        "Hip Width": "21.6",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "19.8",
        "Hip Width": "21.9",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "20.2",
        "Hip Width": "22.3",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "20.6",
        "Hip Width": "22.7",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "20.9",
        "Hip Width": "23.1",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.5",
        "Right Sleeve Length": "24.5",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "21.3",
        "Hip Width": "23.4",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "21.7",
        "Hip Width": "23.8",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.1",
        "Hip Width": "24.2",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "22.4",
        "Hip Width": "24.6",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "22.8",
        "Hip Width": "24.9",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "23.2",
        "Hip Width": "25.3",
        "Center Back Length": "29.5",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "23.6",
        "Hip Width": "25.7",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "23.9",
        "Hip Width": "26.1",
        "Center Back Length": "29.7",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "24.3",
        "Hip Width": "26.4",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25",
        "Right Sleeve Length": "25",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "24.7",
        "Hip Width": "26.8",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.1",
        "Hip Width": "27.2",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "25.4",
        "Hip Width": "27.6",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.2",
        "Right Sleeve Length": "25.2",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "25.9",
        "Hip Width": "28",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "26.3",
        "Hip Width": "28.4",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "15.8",
        "Hip Width": "17.4",
        "Center Back Length": "27.4",
        "Left Sleeve Length": "22.9",
        "Right Sleeve Length": "22.9",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "16.1",
        "Hip Width": "17.7",
        "Center Back Length": "27.5",
        "Left Sleeve Length": "23",
        "Right Sleeve Length": "23",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "16.5",
        "Hip Width": "18.1",
        "Center Back Length": "27.6",
        "Left Sleeve Length": "23.1",
        "Right Sleeve Length": "23.1",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.9",
        "Hip Width": "18.5",
        "Center Back Length": "27.7",
        "Left Sleeve Length": "23.2",
        "Right Sleeve Length": "23.2",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "17.3",
        "Hip Width": "18.9",
        "Center Back Length": "27.8",
        "Left Sleeve Length": "23.3",
        "Right Sleeve Length": "23.3",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "17.6",
        "Hip Width": "19.2",
        "Center Back Length": "27.9",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "18",
        "Hip Width": "19.6",
        "Center Back Length": "28",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "18.4",
        "Hip Width": "20",
        "Center Back Length": "28.1",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "18.8",
        "Hip Width": "20.4",
        "Center Back Length": "28.2",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "19.1",
        "Hip Width": "20.7",
        "Center Back Length": "28.3",
        "Left Sleeve Length": "23.8",
        "Right Sleeve Length": "23.8",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "19.5",
        "Hip Width": "21.1",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "23.9",
        "Right Sleeve Length": "23.9",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.9",
        "Hip Width": "21.5",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "20.3",
        "Hip Width": "21.9",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "20.6",
        "Hip Width": "22.2",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "21",
        "Hip Width": "22.6",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "21.4",
        "Hip Width": "23",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "21.8",
        "Hip Width": "23.4",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.5",
        "Right Sleeve Length": "24.5",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "22.1",
        "Hip Width": "23.7",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "22.5",
        "Hip Width": "24.1",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.9",
        "Hip Width": "24.5",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "23.3",
        "Hip Width": "24.9",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "23.6",
        "Hip Width": "25.2",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "24",
        "Hip Width": "25.6",
        "Center Back Length": "29.5",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "24.4",
        "Hip Width": "26",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "24.8",
        "Hip Width": "26.4",
        "Center Back Length": "29.7",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "25.1",
        "Hip Width": "26.7",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25",
        "Right Sleeve Length": "25",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "25.5",
        "Hip Width": "27.1",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.9",
        "Hip Width": "27.5",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "26.3",
        "Hip Width": "27.9",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.2",
        "Right Sleeve Length": "25.2",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "26.7",
        "Hip Width": "28.3",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Short"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "27.1",
        "Hip Width": "28.7",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "17.3",
        "Hip Width": "17.9",
        "Center Back Length": "27.4",
        "Left Sleeve Length": "22.9",
        "Right Sleeve Length": "22.9",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "17.7",
        "Hip Width": "18.3",
        "Center Back Length": "27.5",
        "Left Sleeve Length": "23",
        "Right Sleeve Length": "23",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "18.1",
        "Hip Width": "18.7",
        "Center Back Length": "27.6",
        "Left Sleeve Length": "23.1",
        "Right Sleeve Length": "23.1",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "18.4",
        "Hip Width": "19",
        "Center Back Length": "27.7",
        "Left Sleeve Length": "23.2",
        "Right Sleeve Length": "23.2",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "18.8",
        "Hip Width": "19.4",
        "Center Back Length": "27.8",
        "Left Sleeve Length": "23.3",
        "Right Sleeve Length": "23.3",
        "Sleeve Bicep Width": "7.5",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "19.2",
        "Hip Width": "19.8",
        "Center Back Length": "27.9",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "19.6",
        "Hip Width": "20.2",
        "Center Back Length": "28",
        "Left Sleeve Length": "23.4",
        "Right Sleeve Length": "23.4",
        "Sleeve Bicep Width": "7.7",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "19.9",
        "Hip Width": "20.5",
        "Center Back Length": "28.1",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "20.3",
        "Hip Width": "20.9",
        "Center Back Length": "28.2",
        "Left Sleeve Length": "23.6",
        "Right Sleeve Length": "23.6",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "20.7",
        "Hip Width": "21.3",
        "Center Back Length": "28.3",
        "Left Sleeve Length": "23.8",
        "Right Sleeve Length": "23.8",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "21.1",
        "Hip Width": "21.7",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "23.9",
        "Right Sleeve Length": "23.9",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "21.4",
        "Hip Width": "22",
        "Center Back Length": "28.4",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.7",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "21.8",
        "Hip Width": "22.4",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "22.2",
        "Hip Width": "22.8",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "22.6",
        "Hip Width": "23.2",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "22.9",
        "Hip Width": "23.5",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "23.3",
        "Hip Width": "23.9",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.5",
        "Right Sleeve Length": "24.5",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "6",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "23.7",
        "Hip Width": "24.3",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "24.1",
        "Hip Width": "24.7",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "24.4",
        "Hip Width": "25",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "24.8",
        "Hip Width": "25.4",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.7",
        "Right Sleeve Length": "24.7",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "25.2",
        "Hip Width": "25.8",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "25.6",
        "Hip Width": "26.2",
        "Center Back Length": "29.5",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "25.9",
        "Hip Width": "26.5",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "26.3",
        "Hip Width": "26.9",
        "Center Back Length": "29.7",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "26.7",
        "Hip Width": "27.3",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25",
        "Right Sleeve Length": "25",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "27.1",
        "Hip Width": "27.7",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "27.4",
        "Hip Width": "28",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "27.8",
        "Hip Width": "28.4",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.2",
        "Right Sleeve Length": "25.2",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "28.3",
        "Hip Width": "28.9",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.8",
        "Length": "Short"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "28.7",
        "Hip Width": "29.3",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.9",
        "Length": "Short"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "14.9",
        "Hip Width": "17.1",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "15.3",
        "Hip Width": "17.4",
        "Center Back Length": "28.7",
        "Left Sleeve Length": "24.2",
        "Right Sleeve Length": "24.2",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "15.7",
        "Hip Width": "17.8",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.1",
        "Hip Width": "18.2",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "16.4",
        "Hip Width": "18.6",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "16.8",
        "Hip Width": "18.9",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "17.2",
        "Hip Width": "19.3",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "17.6",
        "Hip Width": "19.7",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "17.9",
        "Hip Width": "20.1",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "18.3",
        "Hip Width": "20.4",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "18.7",
        "Hip Width": "20.8",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.1",
        "Hip Width": "21.2",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "19.4",
        "Hip Width": "21.6",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "19.8",
        "Hip Width": "21.9",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.5",
        "Right Sleeve Length": "25.5",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "20.2",
        "Hip Width": "22.3",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "20.6",
        "Hip Width": "22.7",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "20.9",
        "Hip Width": "23.1",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.7",
        "Right Sleeve Length": "25.7",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "21.3",
        "Hip Width": "23.4",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "21.7",
        "Hip Width": "23.8",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.1",
        "Hip Width": "24.2",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "22.4",
        "Hip Width": "24.6",
        "Center Back Length": "30.5",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "22.8",
        "Hip Width": "24.9",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "23.2",
        "Hip Width": "25.3",
        "Center Back Length": "30.7",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "23.6",
        "Hip Width": "25.7",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "23.9",
        "Hip Width": "26.1",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "24.3",
        "Hip Width": "26.4",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.2",
        "Right Sleeve Length": "26.2",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "24.7",
        "Hip Width": "26.8",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.1",
        "Hip Width": "27.2",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "25.4",
        "Hip Width": "27.6",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "25.9",
        "Hip Width": "28",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "26.3",
        "Hip Width": "28.4",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "15.8",
        "Hip Width": "17.4",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "16.1",
        "Hip Width": "17.7",
        "Center Back Length": "28.7",
        "Left Sleeve Length": "24.2",
        "Right Sleeve Length": "24.2",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "16.5",
        "Hip Width": "18.1",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.9",
        "Hip Width": "18.5",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "17.3",
        "Hip Width": "18.9",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "17.6",
        "Hip Width": "19.2",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "18",
        "Hip Width": "19.6",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "18.4",
        "Hip Width": "20",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "18.8",
        "Hip Width": "20.4",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "19.1",
        "Hip Width": "20.7",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "19.5",
        "Hip Width": "21.1",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.9",
        "Hip Width": "21.5",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "20.3",
        "Hip Width": "21.9",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "20.6",
        "Hip Width": "22.2",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.5",
        "Right Sleeve Length": "25.5",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "21",
        "Hip Width": "22.6",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "21.4",
        "Hip Width": "23",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "21.8",
        "Hip Width": "23.4",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.7",
        "Right Sleeve Length": "25.7",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "22.1",
        "Hip Width": "23.7",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "22.5",
        "Hip Width": "24.1",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.9",
        "Hip Width": "24.5",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "23.3",
        "Hip Width": "24.9",
        "Center Back Length": "30.5",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "23.6",
        "Hip Width": "25.2",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "24",
        "Hip Width": "25.6",
        "Center Back Length": "30.7",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "24.4",
        "Hip Width": "26",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "24.8",
        "Hip Width": "26.4",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "25.1",
        "Hip Width": "26.7",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.2",
        "Right Sleeve Length": "26.2",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "25.5",
        "Hip Width": "27.1",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.9",
        "Hip Width": "27.5",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "26.3",
        "Hip Width": "27.9",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "26.7",
        "Hip Width": "28.3",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "27.1",
        "Hip Width": "28.7",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "17.3",
        "Hip Width": "17.9",
        "Center Back Length": "28.6",
        "Left Sleeve Length": "24.1",
        "Right Sleeve Length": "24.1",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "17.7",
        "Hip Width": "18.3",
        "Center Back Length": "28.7",
        "Left Sleeve Length": "24.2",
        "Right Sleeve Length": "24.2",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "18.1",
        "Hip Width": "18.7",
        "Center Back Length": "28.8",
        "Left Sleeve Length": "24.3",
        "Right Sleeve Length": "24.3",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "18.4",
        "Hip Width": "19",
        "Center Back Length": "28.9",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "18.8",
        "Hip Width": "19.4",
        "Center Back Length": "29",
        "Left Sleeve Length": "24.4",
        "Right Sleeve Length": "24.4",
        "Sleeve Bicep Width": "7.5",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "19.2",
        "Hip Width": "19.8",
        "Center Back Length": "29.1",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "19.6",
        "Hip Width": "20.2",
        "Center Back Length": "29.2",
        "Left Sleeve Length": "24.6",
        "Right Sleeve Length": "24.6",
        "Sleeve Bicep Width": "7.7",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "19.9",
        "Hip Width": "20.5",
        "Center Back Length": "29.3",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "20.3",
        "Hip Width": "20.9",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.8",
        "Right Sleeve Length": "24.8",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "20.7",
        "Hip Width": "21.3",
        "Center Back Length": "29.4",
        "Left Sleeve Length": "24.9",
        "Right Sleeve Length": "24.9",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "21.1",
        "Hip Width": "21.7",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.1",
        "Right Sleeve Length": "25.1",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "21.4",
        "Hip Width": "22",
        "Center Back Length": "29.6",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "21.8",
        "Hip Width": "22.4",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "22.2",
        "Hip Width": "22.8",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.5",
        "Right Sleeve Length": "25.5",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "22.6",
        "Hip Width": "23.2",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "22.9",
        "Hip Width": "23.5",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "23.3",
        "Hip Width": "23.9",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.7",
        "Right Sleeve Length": "25.7",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "6",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "23.7",
        "Hip Width": "24.3",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "24.1",
        "Hip Width": "24.7",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "24.4",
        "Hip Width": "25",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "24.8",
        "Hip Width": "25.4",
        "Center Back Length": "30.5",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "25.2",
        "Hip Width": "25.8",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "25.6",
        "Hip Width": "26.2",
        "Center Back Length": "30.7",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "25.9",
        "Hip Width": "26.5",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "26.3",
        "Hip Width": "26.9",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "26.7",
        "Hip Width": "27.3",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.2",
        "Right Sleeve Length": "26.2",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "27.1",
        "Hip Width": "27.7",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "27.4",
        "Hip Width": "28",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "27.8",
        "Hip Width": "28.4",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "28.3",
        "Hip Width": "28.9",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.4",
        "Right Sleeve Length": "26.4",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.8",
        "Length": "Regular"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "28.7",
        "Hip Width": "29.3",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.9",
        "Length": "Regular"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "14.9",
        "Hip Width": "17.1",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "15.3",
        "Hip Width": "17.4",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "15.7",
        "Hip Width": "17.8",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.1",
        "Hip Width": "18.2",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "16.4",
        "Hip Width": "18.6",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "16.8",
        "Hip Width": "18.9",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "17.2",
        "Hip Width": "19.3",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "17.6",
        "Hip Width": "19.7",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "17.9",
        "Hip Width": "20.1",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "18.3",
        "Hip Width": "20.4",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "18.7",
        "Hip Width": "20.8",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.1",
        "Hip Width": "21.2",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "19.4",
        "Hip Width": "21.6",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.6",
        "Right Sleeve Length": "26.6",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "19.8",
        "Hip Width": "21.9",
        "Center Back Length": "31",
        "Left Sleeve Length": "26.7",
        "Right Sleeve Length": "26.7",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "20.2",
        "Hip Width": "22.3",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "20.6",
        "Hip Width": "22.7",
        "Center Back Length": "31.2",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "20.9",
        "Hip Width": "23.1",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "21.3",
        "Hip Width": "23.4",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "21.7",
        "Hip Width": "23.8",
        "Center Back Length": "31.5",
        "Left Sleeve Length": "27",
        "Right Sleeve Length": "27",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.1",
        "Hip Width": "24.2",
        "Center Back Length": "31.6",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "22.4",
        "Hip Width": "24.6",
        "Center Back Length": "31.7",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "22.8",
        "Hip Width": "24.9",
        "Center Back Length": "31.8",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "23.2",
        "Hip Width": "25.3",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.2",
        "Right Sleeve Length": "27.2",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "23.6",
        "Hip Width": "25.7",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "23.9",
        "Hip Width": "26.1",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "24.3",
        "Hip Width": "26.4",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "24.7",
        "Hip Width": "26.8",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.1",
        "Hip Width": "27.2",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.5",
        "Right Sleeve Length": "27.5",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "25.4",
        "Hip Width": "27.6",
        "Center Back Length": "32.4",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "25.9",
        "Hip Width": "28",
        "Center Back Length": "32.5",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Long"
    },
    {
        "fit_label": "Extra Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "26.3",
        "Hip Width": "28.4",
        "Center Back Length": "32.6",
        "Left Sleeve Length": "27.7",
        "Right Sleeve Length": "27.7",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "15.8",
        "Hip Width": "17.4",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "7.1",
        "Sleeve Opening Width": "4.9",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "16.1",
        "Hip Width": "17.7",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.2",
        "Sleeve Opening Width": "4.9",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "16.5",
        "Hip Width": "18.1",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "16.9",
        "Hip Width": "18.5",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "17.3",
        "Hip Width": "18.9",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "17.6",
        "Hip Width": "19.2",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "18",
        "Hip Width": "19.6",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "18.4",
        "Hip Width": "20",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "18.8",
        "Hip Width": "20.4",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "19.1",
        "Hip Width": "20.7",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "19.5",
        "Hip Width": "21.1",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "19.9",
        "Hip Width": "21.5",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "8",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "20.3",
        "Hip Width": "21.9",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.6",
        "Right Sleeve Length": "26.6",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "20.6",
        "Hip Width": "22.2",
        "Center Back Length": "31",
        "Left Sleeve Length": "26.7",
        "Right Sleeve Length": "26.7",
        "Sleeve Bicep Width": "8.2",
        "Sleeve Opening Width": "5.7",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "21",
        "Hip Width": "22.6",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "21.4",
        "Hip Width": "23",
        "Center Back Length": "31.2",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "21.8",
        "Hip Width": "23.4",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "22.1",
        "Hip Width": "23.7",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "22.5",
        "Hip Width": "24.1",
        "Center Back Length": "31.5",
        "Left Sleeve Length": "27",
        "Right Sleeve Length": "27",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "22.9",
        "Hip Width": "24.5",
        "Center Back Length": "31.6",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "23.3",
        "Hip Width": "24.9",
        "Center Back Length": "31.7",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "23.6",
        "Hip Width": "25.2",
        "Center Back Length": "31.8",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "24",
        "Hip Width": "25.6",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.2",
        "Right Sleeve Length": "27.2",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "24.4",
        "Hip Width": "26",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "24.8",
        "Hip Width": "26.4",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "25.1",
        "Hip Width": "26.7",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "25.5",
        "Hip Width": "27.1",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "25.9",
        "Hip Width": "27.5",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.5",
        "Right Sleeve Length": "27.5",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "26.3",
        "Hip Width": "27.9",
        "Center Back Length": "32.4",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "26.7",
        "Hip Width": "28.3",
        "Center Back Length": "32.5",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Long"
    },
    {
        "fit_label": "Slim",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "27.1",
        "Hip Width": "28.7",
        "Center Back Length": "32.6",
        "Left Sleeve Length": "27.7",
        "Right Sleeve Length": "27.7",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "30",
        "Shoulder Width/Yoke": "16.4",
        "Chest Width": "18.3",
        "Midsection Width": "17.3",
        "Hip Width": "17.9",
        "Center Back Length": "29.8",
        "Left Sleeve Length": "25.3",
        "Right Sleeve Length": "25.3",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "31",
        "Shoulder Width/Yoke": "16.6",
        "Chest Width": "18.6",
        "Midsection Width": "17.7",
        "Hip Width": "18.3",
        "Center Back Length": "29.9",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.3",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "32",
        "Shoulder Width/Yoke": "16.8",
        "Chest Width": "19",
        "Midsection Width": "18.1",
        "Hip Width": "18.7",
        "Center Back Length": "30",
        "Left Sleeve Length": "25.4",
        "Right Sleeve Length": "25.4",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.1",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "33",
        "Shoulder Width/Yoke": "16.9",
        "Chest Width": "19.4",
        "Midsection Width": "18.4",
        "Hip Width": "19",
        "Center Back Length": "30.1",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.4",
        "Sleeve Opening Width": "5.2",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "34",
        "Shoulder Width/Yoke": "17.1",
        "Chest Width": "19.8",
        "Midsection Width": "18.8",
        "Hip Width": "19.4",
        "Center Back Length": "30.2",
        "Left Sleeve Length": "25.6",
        "Right Sleeve Length": "25.6",
        "Sleeve Bicep Width": "7.5",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "35",
        "Shoulder Width/Yoke": "17.3",
        "Chest Width": "20.1",
        "Midsection Width": "19.2",
        "Hip Width": "19.8",
        "Center Back Length": "30.3",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.6",
        "Sleeve Opening Width": "5.3",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "36",
        "Shoulder Width/Yoke": "17.5",
        "Chest Width": "20.5",
        "Midsection Width": "19.6",
        "Hip Width": "20.2",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.8",
        "Right Sleeve Length": "25.8",
        "Sleeve Bicep Width": "7.7",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "37",
        "Shoulder Width/Yoke": "17.7",
        "Chest Width": "20.9",
        "Midsection Width": "19.9",
        "Hip Width": "20.5",
        "Center Back Length": "30.4",
        "Left Sleeve Length": "25.9",
        "Right Sleeve Length": "25.9",
        "Sleeve Bicep Width": "7.8",
        "Sleeve Opening Width": "5.4",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "38",
        "Shoulder Width/Yoke": "17.9",
        "Chest Width": "21.3",
        "Midsection Width": "20.3",
        "Hip Width": "20.9",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26",
        "Right Sleeve Length": "26",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.5",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "39",
        "Shoulder Width/Yoke": "18.1",
        "Chest Width": "21.6",
        "Midsection Width": "20.7",
        "Hip Width": "21.3",
        "Center Back Length": "30.6",
        "Left Sleeve Length": "26.1",
        "Right Sleeve Length": "26.1",
        "Sleeve Bicep Width": "7.9",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "40",
        "Shoulder Width/Yoke": "18.3",
        "Chest Width": "22",
        "Midsection Width": "21.1",
        "Hip Width": "21.7",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.3",
        "Right Sleeve Length": "26.3",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.6",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "41",
        "Shoulder Width/Yoke": "18.4",
        "Chest Width": "22.4",
        "Midsection Width": "21.4",
        "Hip Width": "22",
        "Center Back Length": "30.8",
        "Left Sleeve Length": "26.5",
        "Right Sleeve Length": "26.5",
        "Sleeve Bicep Width": "8.1",
        "Sleeve Opening Width": "5.7",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "42",
        "Shoulder Width/Yoke": "18.6",
        "Chest Width": "22.8",
        "Midsection Width": "21.8",
        "Hip Width": "22.4",
        "Center Back Length": "30.9",
        "Left Sleeve Length": "26.6",
        "Right Sleeve Length": "26.6",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "43",
        "Shoulder Width/Yoke": "18.8",
        "Chest Width": "23.1",
        "Midsection Width": "22.2",
        "Hip Width": "22.8",
        "Center Back Length": "31",
        "Left Sleeve Length": "26.7",
        "Right Sleeve Length": "26.7",
        "Sleeve Bicep Width": "8.3",
        "Sleeve Opening Width": "5.8",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "44",
        "Shoulder Width/Yoke": "19",
        "Chest Width": "23.5",
        "Midsection Width": "22.6",
        "Hip Width": "23.2",
        "Center Back Length": "31.1",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.4",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "45",
        "Shoulder Width/Yoke": "19.2",
        "Chest Width": "23.9",
        "Midsection Width": "22.9",
        "Hip Width": "23.5",
        "Center Back Length": "31.2",
        "Left Sleeve Length": "26.8",
        "Right Sleeve Length": "26.8",
        "Sleeve Bicep Width": "8.5",
        "Sleeve Opening Width": "5.9",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "46",
        "Shoulder Width/Yoke": "19.4",
        "Chest Width": "24.3",
        "Midsection Width": "23.3",
        "Hip Width": "23.9",
        "Center Back Length": "31.3",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.6",
        "Sleeve Opening Width": "6",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "47",
        "Shoulder Width/Yoke": "19.6",
        "Chest Width": "24.6",
        "Midsection Width": "23.7",
        "Hip Width": "24.3",
        "Center Back Length": "31.4",
        "Left Sleeve Length": "26.9",
        "Right Sleeve Length": "26.9",
        "Sleeve Bicep Width": "8.7",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "48",
        "Shoulder Width/Yoke": "19.8",
        "Chest Width": "25",
        "Midsection Width": "24.1",
        "Hip Width": "24.7",
        "Center Back Length": "31.5",
        "Left Sleeve Length": "27",
        "Right Sleeve Length": "27",
        "Sleeve Bicep Width": "8.8",
        "Sleeve Opening Width": "6.1",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "49",
        "Shoulder Width/Yoke": "19.9",
        "Chest Width": "25.4",
        "Midsection Width": "24.4",
        "Hip Width": "25",
        "Center Back Length": "31.6",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "8.9",
        "Sleeve Opening Width": "6.2",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "50",
        "Shoulder Width/Yoke": "20.1",
        "Chest Width": "25.8",
        "Midsection Width": "24.8",
        "Hip Width": "25.4",
        "Center Back Length": "31.7",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "9",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "51",
        "Shoulder Width/Yoke": "20.3",
        "Chest Width": "26.1",
        "Midsection Width": "25.2",
        "Hip Width": "25.8",
        "Center Back Length": "31.8",
        "Left Sleeve Length": "27.1",
        "Right Sleeve Length": "27.1",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.3",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "52",
        "Shoulder Width/Yoke": "20.5",
        "Chest Width": "26.5",
        "Midsection Width": "25.6",
        "Hip Width": "26.2",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.2",
        "Right Sleeve Length": "27.2",
        "Sleeve Bicep Width": "9.1",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "53",
        "Shoulder Width/Yoke": "20.7",
        "Chest Width": "26.9",
        "Midsection Width": "25.9",
        "Hip Width": "26.5",
        "Center Back Length": "31.9",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.2",
        "Sleeve Opening Width": "6.4",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "54",
        "Shoulder Width/Yoke": "20.9",
        "Chest Width": "27.3",
        "Midsection Width": "26.3",
        "Hip Width": "26.9",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.3",
        "Right Sleeve Length": "27.3",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.5",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "55",
        "Shoulder Width/Yoke": "21.1",
        "Chest Width": "27.6",
        "Midsection Width": "26.7",
        "Hip Width": "27.3",
        "Center Back Length": "32.1",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.3",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "56",
        "Shoulder Width/Yoke": "21.3",
        "Chest Width": "28",
        "Midsection Width": "27.1",
        "Hip Width": "27.7",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.4",
        "Right Sleeve Length": "27.4",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.6",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "57",
        "Shoulder Width/Yoke": "21.4",
        "Chest Width": "28.4",
        "Midsection Width": "27.4",
        "Hip Width": "28",
        "Center Back Length": "32.3",
        "Left Sleeve Length": "27.5",
        "Right Sleeve Length": "27.5",
        "Sleeve Bicep Width": "9.4",
        "Sleeve Opening Width": "6.7",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "58",
        "Shoulder Width/Yoke": "21.6",
        "Chest Width": "28.8",
        "Midsection Width": "27.8",
        "Hip Width": "28.4",
        "Center Back Length": "32.4",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.5",
        "Sleeve Opening Width": "6.8",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "59",
        "Shoulder Width/Yoke": "21.8",
        "Chest Width": "29.2",
        "Midsection Width": "28.3",
        "Hip Width": "28.9",
        "Center Back Length": "32.5",
        "Left Sleeve Length": "27.6",
        "Right Sleeve Length": "27.6",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.8",
        "Length": "Long"
    },
    {
        "fit_label": "Classic",
        "SIZE  US": "60",
        "Shoulder Width/Yoke": "22",
        "Chest Width": "29.6",
        "Midsection Width": "28.7",
        "Hip Width": "29.3",
        "Center Back Length": "32.6",
        "Left Sleeve Length": "27.7",
        "Right Sleeve Length": "27.7",
        "Sleeve Bicep Width": "9.6",
        "Sleeve Opening Width": "6.9",
        "Length": "Long"
    }
]